import Utils from '../../Utils.js';

export async function handleImagePaste(data, position) {
  const file = new File([data], "pasted-image.png", { type: data.type });
  await Utils.insertImage({ file, position });
}